import React from "react";

import { useTranslation, Trans } from "react-i18next";

import img1 from '../../img/Trade/img.png'
import img2 from '../../img/Trade/img2.png'

function TradeOn () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative pt-[80px] xl:pt-[160px]">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
               <div className="flex flex-col xl:flex-row justify-between gap-[20px]">
                    <div>
                        <p className="text-[30px] xl:text-[40px] italic font-[700] merriweather"><Trans>{t('trade.27')}</Trans></p>
                        <p className="mt-[15px] xl:mt-[30px] inter text-[14px] xl:text-[16px] font-[300] xl:max-w-[490px] fdfd"><Trans>{t('trade.28')}</Trans></p>
                        <p className="mt-[15px] xl:mt-[30px] inter text-[14px] xl:text-[16px] font-[300] xl:max-w-[490px] fdfd"><Trans>{t('trade.29')}</Trans></p>
                        <p className="mt-[15px] inter text-[14px] xl:text-[16px] font-[300] xl:max-w-[490px] fdfd"><Trans>{t('trade.30')}</Trans></p>
                    </div>
                    <img src={img1} className="mx-auto xl:mx-0" alt="" />
               </div>
               <div className="flex flex-col xl:flex-row-reverse justify-between gap-[20px] mt-[50px]">
                    <div>
                        <p className="xl:mt-[30px] inter text-[14px] xl:text-[16px] font-[300] xl:max-w-[490px] fdfd"><Trans>{t('trade.31')}</Trans></p>
                        <p className="mt-[15px] inter text-[14px] xl:text-[16px] font-[300] xl:max-w-[490px] fdfd"><Trans>{t('trade.32')}</Trans></p>
                        <p className="mt-[30px] inter text-[14px] xl:text-[16px] font-[300] xl:max-w-[490px] fdfd"><Trans>{t('trade.33')}</Trans></p>
                        <p className="mt-[15px] inter text-[14px] xl:text-[16px] font-[300] xl:max-w-[490px] fdfd"><Trans>{t('trade.34')}</Trans></p>
                        <p className="mt-[30px] inter text-[14px] xl:text-[16px] font-[300] xl:max-w-[490px] fdfd"><Trans>{t('trade.35')}</Trans></p>
                        <p className="mt-[15px] inter text-[14px] xl:text-[16px] font-[300] xl:max-w-[490px] fdfd"><Trans>{t('trade.36')}</Trans></p>
                    </div>
                    <img src={img2} className="mx-auto xl:mx-0" alt="" />
               </div>
            </div>
        </div>
    );
}

export default TradeOn;